window.Icon = (name) ->
  return P.i("fa fa-#{name}")

